// extracted by mini-css-extract-plugin
module.exports = {"ratingSection":"CourseRatingView_ratingSection__ERSMD","rateValue":"CourseRatingView_rateValue__5OUj5","ratingCount":"CourseRatingView_ratingCount__K9Gl_"};